module.exports = __webpack_public_path__ + "img/ic_feedback_edit.691401a3.png";